import React, { useEffect, useMemo } from 'react'
import { Col, Form, Input, Row, Select, Spin } from 'antd'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { isEqual } from 'lodash'
import { getActiveTemplateAction } from 'slices/template'

const { Item } = Form
const { TextArea } = Input

interface Props {
	canEditBroadcast: boolean
}

const BroadcastFormTemplate: React.FC<Props> = ({ canEditBroadcast }) => {
	const activeTemplates = useAppSelector(
		state => state.template.activeTemplates,
		isEqual
	)

	/**
	 * Discuss with team about this piece of code
	 */
	const dispatch = useAppDispatch()
	useEffect(() => {
		dispatch(getActiveTemplateAction())
	}, [])

	const loadingTemplate = useAppSelector(state => state.template.loading)
	const currentTemplate = useAppSelector(
		state => state.broadcast.broadcast?.template
	)

	const templateOptions = useMemo(() => {
		let activeTemplateOptions = activeTemplates.map(template => ({
			value: template._id,
			label: `${template.label} (${template.language.label})`,
		}))

		if (
			currentTemplate &&
			typeof currentTemplate !== 'string' &&
			activeTemplateOptions.find(
				template => template.value === currentTemplate._id
			) === undefined
		) {
			activeTemplateOptions = [
				{
					value: currentTemplate._id,
					label: `${currentTemplate.label} (${currentTemplate.language.label})`,
				},
				...activeTemplateOptions,
			]
		}

		return activeTemplateOptions
	}, [activeTemplates, currentTemplate])

	return (
		<Spin spinning={loadingTemplate} tip='Loading Templates'>
			<Row>
				<Col xxl={8} xl={12}>
					<Item
						name='template'
						label='Select Template *'
						rules={[
							{
								required: true,
								message: 'Please select a template',
							},
						]}
					>
						<Select
							placeholder='Select Template'
							optionFilterProp='label'
							showSearch
							options={templateOptions}
							disabled={!canEditBroadcast}
						/>
					</Item>

					<Item name='templatePreview'>
						<TextArea disabled />
					</Item>
				</Col>
			</Row>
		</Spin>
	)
}

export default BroadcastFormTemplate
